<template>
    <div class="gyss_container">
        <!-- 顶部切换：山水绿胶囊 + 木金下划线 -->
        <div class="tabs_btns_container">
            <button
                class="gyss_btn"
                v-for="item in gyssInfo"
                :key="item.typeId"
                :class="{ gyss_btn_active: tabTypeId === item.typeId }"
                @click="changeTab(item.typeId)">
                {{ item.typeName }}
            </button>
        </div>

        <div class="tabs_content_container">
            <!-- ============ 1. 山水介绍 ============ -->
            <div v-if="tabTypeId === 1" class="tabs_content_item">
                <div class="ss_section_head reveal-init" v-reveal>
                    <span class="ss_kicker">01 / 山水介绍</span>
                    <h2 class="ss_title">山水之道 · 源远流长</h2>
                    <span class="ss_rule"></span>
                </div>
                <div class="ssjs_container reveal-init" v-if="ssjsInfo && ssjsInfo.text" v-reveal>
                    <div class="ssjs_lead" v-html="ssjsInfo.text"></div>
                </div>
                <div class="ssjs_container reveal-init" v-else v-reveal>
                    <i class="el-icon-loading"></i>
                </div>
            </div>

            <!-- ============ 2. 山水荣誉 ============ -->
            <div v-if="tabTypeId === 2" class="tabs_content_item">
                <div class="ss_section_head reveal-init" v-reveal>
                    <span class="ss_kicker">02 / 山水荣誉</span>
                    <h2 class="ss_title">荣誉殿堂 · 实至名归</h2>
                    <span class="ss_rule"></span>
                </div>
                <!-- 分类筛选 -->
                <div class="ssry_type_container reveal-init" v-reveal>
                    <button
                        class="ssry_type_btn"
                        v-for="item in ssryTypeInfo"
                        :key="item.value"
                        :class="{ ssry_type_active: ssryActive === item.value }"
                        @click="showSsryInfoFun(item.value)">
                        {{ item.text.trim() }}
                    </button>
                </div>
                <!-- 荣誉墙网格（替代单排快播轮播） -->
                <div class="ssry_grid" v-if="ssryInfo.length > 0">
                    <div
                        class="ssry_card reveal-init"
                        v-for="(item, i) in ssryInfo"
                        :key="item.honourid"
                        v-reveal="Math.min(i * 70, 560)">
                        <div class="ssry_card_img">
                            <img v-if="item.honourimgurl" :src="item.honourimgurl" alt="" @error="onImgError" />
                            <i v-else class="el-icon-picture-outline"></i>
                        </div>
                        <div class="ssry_card_cap" v-if="item.honourname">{{ item.honourname }}</div>
                    </div>
                </div>
                <div class="ssry_empty reveal-init" v-else v-reveal>暂无数据</div>
            </div>

            <!-- ============ 3. 成长历程 ============ -->
            <div v-if="tabTypeId === 3" class="tabs_content_item">
                <div class="ss_section_head reveal-init" v-reveal>
                    <span class="ss_kicker">03 / 成长历程</span>
                    <h2 class="ss_title">步履不停 · 岁月留痕</h2>
                    <span class="ss_rule"></span>
                </div>
                <div class="czlc_timeline">
                    <div
                        class="czlc_node reveal-init"
                        v-for="(yr, yi) in cclcInfo"
                        :key="yr.year"
                        v-reveal="Math.min(yi * 90, 600)">
                        <div class="czlc_axis">
                            <span class="czlc_dot"></span>
                        </div>
                        <div class="czlc_body">
                            <div class="czlc_year">{{ yr.year }}</div>
                            <div class="czlc_card" v-for="items in yr.data" :key="items.czlcdate">
                                <div class="czlc_date">{{ items.czlcdate }}</div>
                                <div class="czlc_text" v-html="items.czlctext"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ============ 4. 企业核心 ============ -->
            <div v-if="tabTypeId === 4" class="tabs_content_item">
                <div class="ss_section_head reveal-init" v-reveal>
                    <span class="ss_kicker">04 / 企业核心</span>
                    <h2 class="ss_title">五核驱动 · 匠心筑造</h2>
                    <span class="ss_rule"></span>
                </div>
                <div class="hxbk_grid" v-if="hxbk.length > 0">
                    <div
                        class="hxbk_card reveal-init"
                        v-for="(item, i) in hxbk"
                        :key="item.typeId || item.id || i"
                        v-reveal="Math.min(i * 90, 600)">
                        <div class="hxbk_img">
                            <el-image :src="item.bkimgurl" fit="cover">
                                <div slot="placeholder" class="image-slot">加载中<span class="dot">...</span></div>
                                <div slot="error" class="image-slot"><i class="el-icon-picture-outline"></i></div>
                            </el-image>
                        </div>
                        <div class="hxbk_veil"></div>
                        <div class="hxbk_label">
                            <span class="hxbk_index">{{ String(i + 1).padStart(2, '0') }}</span>
                            <span class="hxbk_name">{{ item.bkname }}</span>
                        </div>
                    </div>
                </div>
                <div class="hxbk_grid" v-else>
                    <div class="hxbk_card reveal-init" v-for="(item, i) in hxbkMock" :key="i" v-reveal="i * 90">
                        <div class="hxbk_img">
                            <el-image :src="item.bkimgurl" fit="cover">
                                <div slot="error" class="image-slot"><i class="el-icon-picture-outline"></i></div>
                            </el-image>
                        </div>
                        <div class="hxbk_veil"></div>
                        <div class="hxbk_label">
                            <span class="hxbk_index">{{ String(i + 1).padStart(2, '0') }}</span>
                            <span class="hxbk_name">{{ item.typeName }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ============ 5. 山水党建 ============ -->
            <div v-if="tabTypeId === 5" class="tabs_content_item">
                <div class="ss_section_head reveal-init" v-reveal>
                    <span class="ss_kicker">05 / 山水党建</span>
                    <h2 class="ss_title">红色领航 · 山水党旗</h2>
                    <span class="ss_rule"></span>
                </div>
                <div class="ssdj_carousel_container reveal-init" v-if="ssdj.carousel.length > 0" v-reveal>
                    <el-carousel arrow="hover" height="100%" indicator-position="outside" :interval="5000" :pause-on-hover="true">
                        <el-carousel-item v-for="item in ssdj.carousel" :key="item.articleid">
                            <div class="ssdj_carousel_content_container">
                                <div class="ssdj_carousel_img_container">
                                    <el-image :src="item.articlecarouselimg" fit="cover">
                                        <div slot="error" class="image-slot"><i class="el-icon-picture-outline"></i></div>
                                    </el-image>
                                </div>
                                <div class="ssdj_carousel_words_container">
                                    <div class="ssdj_carousel_title_container">{{ item.articletitle }}</div>
                                    <div class="ssdj_carousel_date_container">
                                        日期：{{ item.articledate }}
                                        <el-button type="text" @click="showArticleDeltail(item)">查看详情</el-button>
                                    </div>
                                    <div class="ssdj_carousel_text_container" v-html="item.articletext"></div>
                                </div>
                            </div>
                        </el-carousel-item>
                    </el-carousel>
                </div>
                <div class="ssdj_articleList_container" v-if="ssdj.articleContent.length > 0">
                    <div
                        class="ssdj_articleItem_container reveal-init"
                        v-for="(item, i) in ssdj.articleContent"
                        :key="item.articleid"
                        v-reveal="Math.min(i * 80, 560)"
                        @click="showArticleDeltail(item)">
                        <div class="ssdj_article_img_container">
                            <el-image :src="item.articlefaceimg" fit="cover">
                                <div slot="error" class="image-slot"><i class="el-icon-picture-outline"></i></div>
                            </el-image>
                        </div>
                        <div class="ssdj_article_text_container">
                            <div class="ssdj_article_title_container">{{ item.articletitle }}</div>
                            <div class="ssdj_article_date_container">
                                日期：{{ item.articledate }}
                                <el-button type="text" @click.stop="showArticleDeltail(item)">查看详情</el-button>
                            </div>
                            <div class="ssdj_article_words_container" v-html="item.articletext"></div>
                        </div>
                    </div>
                    <div class="ssdj_articlePage_container">
                        <el-pagination
                            layout="prev, pager, next"
                            @current-change="pageChanged"
                            :current-page="pageInfo.currentPage"
                            :total="pageInfo.totals"
                            :page-size="pageInfo.pageSize">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// 轻量进场指令：进入视口才动，支持错峰延迟，自然缓动。不依赖任何第三方库。
// 关键：内容默认可见，reveal-in 仅触发「渐显」关键帧动画；即使 observer 未触发，内容也不会被藏死。
const reveal = {
  inserted (el, binding) {
    el.classList.add('reveal-init')
    const delay = binding.value || 0
    el.style.setProperty('--reveal-delay', delay + 'ms')
    const revealNow = () => {
      el.classList.add('reveal-in')
      if (el.__revealIO__) el.__revealIO__.unobserve(el)
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) revealNow()
      })
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' })
    io.observe(el)
    el.__revealIO__ = io
    // 已在视口内：inserted 阶段同步加 class（下一帧绘制前），既播放渐显又无闪烁；
    // 不在视口：滚动到位时由 observer 触发；observer 若始终未触发，元素仍为默认可见态。
    const vh = window.innerHeight || document.documentElement.clientHeight
    const rect = el.getBoundingClientRect()
    if (rect.top < vh && rect.bottom > 0) {
      revealNow()
    }
  },
  unbind (el) {
    if (el.__revealIO__) el.__revealIO__.disconnect()
  }
}

export default {
  directives: { reveal },
  data () {
    return {
      tabTypeId: 1,
      ssryActive: '0',
      gyssInfo: [
        { typeName: '山水介绍', typeId: 1 },
        { typeName: '山水荣誉', typeId: 2 },
        { typeName: '成长历程', typeId: 3 },
        { typeName: '企业核心', typeId: 4 },
        { typeName: '山水党建', typeId: 5 }
      ],
      ssjsInfo: {},
      ssryInfo: [],
      cclcInfo: [],
      hxbk: [],
      hxbkMock: [
        { typeName: '设计', bkimgurl: 'https://ssjt.buildone.com.cn//hxbk/%E7%8E%B0%E5%9C%A8%E7%9A%84%E6%80%BB%E9%83%A8%E5%A4%A7%E6%A5%BC%20%282%29202010281646554895.jpg' },
        { typeName: '咨询', bkimgurl: 'https://ssjt.buildone.com.cn//hxbk/%E7%8E%B0%E5%9C%A8%E7%9A%84%E6%80%BB%E9%83%A8%E5%A4%A7%E6%A5%BC%20%282%29202010281646554895.jpg' },
        { typeName: '监理', bkimgurl: 'https://ssjt.buildone.com.cn//hxbk/%E9%9B%86%E5%9B%A2%E6%80%BB%E9%83%A8%E8%8A%B1%E5%9B%AD%E5%81%87%E5%B1%B1ds202011111006121048.jpg' },
        { typeName: '施工', bkimgurl: 'https://ssjt.buildone.com.cn//hxbk/%E9%9B%86%E5%9B%A2%E6%80%BB%E9%83%A8%E8%8A%B1%E5%9B%AD%E5%81%87%E5%B1%B1ds202011111006121048.jpg' },
        { typeName: '科研', bkimgurl: 'https://ssjt.buildone.com.cn//hxbk/%E9%9B%86%E5%9B%A2%E6%80%BB%E9%83%A8%E8%8A%B1%E5%9B%AD%E5%81%87%E5%B1%B1ds202011111006121048.jpg' }
      ],
      ssdj: {
        carousel: [],
        articleContent: []
      },
      pageInfo: {
        currentPage: 1,
        totals: 50,
        pageSize: 3
      },
      ssryTypeInfo: [
        { text: ' 山水资质', value: '0' },
        { text: '企业荣誉', value: '1' },
        { text: '工程荣誉 ', value: '2' },
        { text: '科研荣誉', value: '3' },
        { text: '山水形象', value: '4' }
      ]
    }
  },
  methods: {
    onImgError (e) {
      e.target.style.display = 'none'
    },
    // 获取党建文章轮播
    queryCarouselByType () {
      this.$http.post('/admin/queryCarouselByType/2').then(res => {
        this.ssdj.carousel = res.data.data
      })
    },
    getSsdjByPage () {
      this.$http.post('/admin/getArticleByType/1', this.pageInfo).then(res => {
        this.ssdj.articleContent = res.data.articles
        this.pageInfo.totals = res.data.totals
      })
    },
    // 获取企业核心
    getHxbk () {
      this.$http.get('/admin/getHxbk').then(res => {
        this.hxbk = res.data.data
      }).catch(() => {})
    },
    // 获取成长历程
    getCzlc () {
      this.$http.get('/admin/getCzlc').then(res => {
        const _data = res.data.data
        const year = []
        const dataArray = []
        _data.forEach(item => {
          if (!year.includes(item.czlcdate.substring(0, 4))) {
            year.push(item.czlcdate.substring(0, 4))
          }
        })
        year.forEach(itemY => {
          const text = []
          _data.forEach(item => {
            if (itemY === item.czlcdate.substring(0, 4)) {
              text.push(item)
            }
          })
          dataArray.push({ year: itemY, data: text })
        })
        this.cclcInfo = dataArray
      }).catch(() => {})
    },
    // 获取山水介绍
    getSimpleText () {
      this.$http.post('/admin/getSimpleTextByType/0').then(res => {
        if (res.data.data.length > 0) {
          this.ssjsInfo = res.data.data[0]
        }
      })
    },
    // 获取山水荣誉
    showSsryInfoFun (typeId) {
      this.ssryActive = String(typeId)
      this.ssryInfo = []
      this.$http.post('/admin/getHonourByType/' + typeId).then(res => {
        this.ssryInfo = res.data.data
      })
    },
    changeTab (typeId) {
      this.tabTypeId = Number(typeId)
      window.sessionStorage.setItem('tabTypeId', this.tabTypeId)
      // 切 tab 时复位整页滚动，否则从已滚动的长 tab 切回顶部 tab 时，
      // 内容处于视口上方，进场动画的 IntersectionObserver 永不触发而整块不显示
      window.scrollTo(0, 0)
    },
    showArticleDeltail (data) {
      window.sessionStorage.setItem('articleDetail', JSON.stringify(data))
      window.sessionStorage.setItem('activeIndex', '/gyss')
      this.$router.push('articleDetail')
    },
    pageChanged (currentPage) {
      this.pageInfo.currentPage = currentPage
      this.getSsdjByPage()
    }
  },
  created () {
    this.getSimpleText()
    this.showSsryInfoFun(0)
    this.getCzlc()
    this.getHxbk()
    this.queryCarouselByType()
    this.getSsdjByPage()
    const saved = Number(window.sessionStorage.getItem('tabTypeId'))
    this.tabTypeId = saved || 1
  }
}
</script>

<style lang="less" scoped>
// 山水绿自然风主题变量
.gyss_container {
    --ss-green-800: #163a2b;
    --ss-green: #2e6b4f;
    --ss-green-200: #9fd3b8;
    --ss-sand: #f7f5f0;
    --ss-gold: #c9a86a;
    width: 100%;
    min-height: 200px;
    background-color: var(--ss-sand);
    border-radius: 8px;
    padding: 8px 4px 28px;
}

// 顶部胶囊切换
.tabs_btns_container {
    width: 100%;
    padding: 14px 10px 10px;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px;
    border-bottom: 1px solid rgba(22, 58, 43, 0.12);
}
.gyss_btn {
    padding: 8px 18px;
    background-color: transparent;
    border: 1px solid transparent;
    border-radius: 20px;
    color: #6b7a72;
    font-size: 15px;
    cursor: pointer;
    transition: all .35s cubic-bezier(.22,.61,.36,1);
}
.gyss_btn:hover {
    color: var(--ss-green);
    background-color: rgba(46, 107, 79, 0.08);
}
.gyss_btn_active {
    color: #fff;
    background-color: var(--ss-green);
    box-shadow: 0 4px 12px rgba(46, 107, 79, 0.25);
}

.tabs_content_container {
    width: 100%;
    padding: 6px 18px;
}
.tabs_content_item {
    width: 100%;
    min-height: 450px;
}

// 通用 section 头（墨迹晕开 + 木金分隔线）
.ss_section_head {
    padding: 26px 0 18px;
    text-align: center;
}
.ss_kicker {
    display: inline-block;
    font-size: 13px;
    letter-spacing: 3px;
    color: var(--ss-gold);
    font-weight: 500;
}
.ss_title {
    margin: 8px 0 0;
    font-size: 30px;
    font-weight: 500;
    color: var(--ss-green-800);
    letter-spacing: 2px;
}
.ss_rule {
    display: block;
    width: 64px;
    height: 3px;
    margin: 14px auto 0;
    background: linear-gradient(90deg, var(--ss-gold), transparent);
    border-radius: 2px;
}

// 进场动画基类：默认可见，仅进场时播放渐显动画（避免动画未触发导致内容永久隐藏）
.reveal-init.reveal-in {
    animation: revealUp .7s cubic-bezier(.22,.61,.36,1) both;
    animation-delay: var(--reveal-delay, 0ms);
}
@keyframes revealUp {
    from { opacity: 0; transform: translateY(28px); }
    to { opacity: 1; transform: none; }
}

// ============ 1. 山水介绍 ============
.ssjs_container {
    max-width: 880px;
    margin: 0 auto;
    padding: 10px 0 30px;
    font-size: 16px;
    line-height: 2;
    color: #3a4a42;
}
.ssjs_container ::v-deep .ssjs_lead {
    text-align: justify;
}
.ssjs_container i {
    display: block;
    text-align: center;
    font-size: 36px;
    color: var(--ss-green);
    padding: 60px 0;
}

// ============ 2. 山水荣誉 ============
.ssry_type_container {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 10px;
    margin: 6px 0 22px;
}
.ssry_type_btn {
    padding: 7px 18px;
    border: 1px solid rgba(22, 58, 43, 0.2);
    border-radius: 18px;
    background: #fff;
    color: #5f6f66;
    font-size: 14px;
    cursor: pointer;
    transition: all .3s cubic-bezier(.22,.61,.36,1);
}
.ssry_type_btn:hover {
    border-color: var(--ss-green);
    color: var(--ss-green);
}
.ssry_type_active {
    background: var(--ss-green);
    border-color: var(--ss-green);
    color: #fff;
}
.ssry_grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 18px;
    padding: 4px 4px 20px;
}
.ssry_card {
    background: #fff;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid rgba(22, 58, 43, 0.08);
    transition: box-shadow .4s cubic-bezier(.22,.61,.36,1), transform .4s cubic-bezier(.22,.61,.36,1);
}
.ssry_card_img {
    width: 100%;
    height: 220px;
    background: #eef1ee;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}
.ssry_card_img img {
    width: 100%;
    height: 100%;
    object-fit: contain;
    transition: transform .6s cubic-bezier(.22,.61,.36,1);
}
.ssry_card:hover {
    box-shadow: 0 10px 26px rgba(22, 58, 43, 0.18);
    transform: translateY(-4px);
}
.ssry_card:hover .ssry_card_img img {
    transform: scale(1.06);
}
.ssry_card_cap {
    padding: 10px 14px;
    font-size: 14px;
    color: var(--ss-green-800);
    text-align: center;
    border-top: 2px solid var(--ss-gold);
}
.ssry_empty {
    text-align: center;
    color: #9aa6a0;
    padding: 60px 0;
}

// ============ 3. 成长历程 ============
.czlc_timeline {
    max-width: 760px;
    margin: 10px auto 30px;
    padding: 6px 0;
}
.czlc_node {
    position: relative;
    display: flex;
    gap: 20px;
    padding-bottom: 30px;
}
.czlc_axis {
    position: relative;
    width: 22px;
    flex: 0 0 22px;
    display: flex;
    justify-content: center;
}
.czlc_axis::before {
    content: '';
    position: absolute;
    top: 8px;
    bottom: -30px;
    width: 2px;
    background: var(--ss-green-200);
}
.czlc_node:last-child .czlc_axis::before {
    display: none;
}
.czlc_dot {
    position: relative;
    z-index: 2;
    width: 16px;
    height: 16px;
    margin-top: 4px;
    border-radius: 50%;
    background: var(--ss-green);
    box-shadow: 0 0 0 4px rgba(46, 107, 79, 0.18);
    animation: ssPulse 2.4s ease-in-out infinite;
}
@keyframes ssPulse {
    0% { box-shadow: 0 0 0 0 rgba(46, 107, 79, 0.45); }
    70% { box-shadow: 0 0 0 12px rgba(46, 107, 79, 0); }
    100% { box-shadow: 0 0 0 0 rgba(46, 107, 79, 0); }
}
.czlc_body { flex: 1; }
.czlc_year {
    font-size: 22px;
    font-weight: 500;
    color: var(--ss-green-800);
    margin-bottom: 10px;
}
.czlc_card {
    background: #fff;
    border-left: 3px solid var(--ss-gold);
    border-radius: 6px;
    padding: 12px 16px;
    margin-bottom: 12px;
    box-shadow: 0 3px 10px rgba(22, 58, 43, 0.06);
}
.czlc_date {
    font-size: 13px;
    color: var(--ss-gold);
    margin-bottom: 6px;
}
.czlc_text {
    font-size: 15px;
    line-height: 1.8;
    color: #3a4a42;
}

// ============ 4. 企业核心 ============
.hxbk_grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 16px;
    padding: 6px 2px 20px;
}
.hxbk_card {
    position: relative;
    height: 320px;
    border-radius: 10px;
    overflow: hidden;
    cursor: default;
    box-shadow: 0 4px 14px rgba(22, 58, 43, 0.1);
}
.hxbk_img {
    width: 100%;
    height: 100%;
}
.hxbk_img ::v-deep .el-image,
.hxbk_img ::v-deep img {
    width: 100%;
    height: 100%;
    transition: transform .7s cubic-bezier(.22,.61,.36,1);
}
.hxbk_card:hover .hxbk_img ::v-deep img {
    transform: scale(1.08);
}
.hxbk_veil {
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(22, 58, 43, 0.05) 30%, rgba(22, 58, 43, 0.78) 100%);
    transition: background .4s ease;
}
.hxbk_card:hover .hxbk_veil {
    background: linear-gradient(180deg, rgba(22, 58, 43, 0.2) 20%, rgba(22, 58, 43, 0.85) 100%);
}
.hxbk_label {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    padding: 16px 14px;
    color: #fff;
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.hxbk_index {
    font-size: 13px;
    letter-spacing: 2px;
    color: var(--ss-gold);
}
.hxbk_name {
    font-size: 19px;
    font-weight: 500;
    letter-spacing: 2px;
}

// ============ 5. 山水党建 ============
.ssdj_carousel_container {
    width: 100%;
    height: 420px;
    background-color: #eef1ee;
    border-radius: 10px;
    overflow: hidden;
    margin-bottom: 24px;
}
.ssdj_carousel_container ::v-deep .el-carousel { height: 100%; }
.ssdj_carousel_content_container {
    width: 100%;
    height: 100%;
    display: flex;
    padding: 18px;
}
.ssdj_carousel_img_container {
    width: 42%;
    height: 100%;
    border-radius: 8px;
    overflow: hidden;
}
.ssdj_carousel_img_container ::v-deep .el-image,
.ssdj_carousel_img_container ::v-deep img {
    width: 100%;
    height: 100%;
}
.ssdj_carousel_words_container {
    width: 58%;
    height: 100%;
    padding: 8px 26px;
    overflow: hidden;
}
.ssdj_carousel_title_container {
    width: 100%;
    font-size: 26px;
    font-weight: 500;
    color: var(--ss-green-800);
    height: 44px;
    line-height: 44px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.ssdj_carousel_date_container {
    width: 100%;
    color: #a9b0ab;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 6px 0 10px;
}
.ssdj_carousel_text_container {
    width: 100%;
    height: 300px;
    color: #3a4a42;
    font-size: 16px;
    line-height: 30px;
    letter-spacing: 0.04em;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 10;
    -webkit-box-orient: vertical;
}
.ssdj_articleList_container {
    width: 100%;
    min-height: 200px;
    padding: 4px 0;
}
// 报刊细线：去白底阴影，仅木金发丝线分隔
.ssdj_articleItem_container {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 18px;
    padding: 18px 6px;
    cursor: pointer;
    border-bottom: 1px solid var(--ss-green-200);
    transition: background .3s ease;
}
.ssdj_articleItem_container:hover {
    background: rgba(46, 107, 79, 0.05);
}
.ssdj_article_img_container {
    width: 132px;
    height: 96px;
    flex: 0 0 132px;
    border-radius: 8px;
    overflow: hidden;
}
.ssdj_article_img_container ::v-deep .el-image,
.ssdj_article_img_container ::v-deep img {
    width: 100%;
    height: 100%;
    transition: transform .6s cubic-bezier(.22,.61,.36,1);
}
.ssdj_articleItem_container:hover .ssdj_article_img_container ::v-deep img {
    transform: scale(1.06);
}
.ssdj_article_text_container {
    flex: 1;
    min-width: 0;
    padding: 0;
}
.ssdj_article_title_container {
    display: inline-block;
    max-width: 100%;
    position: relative;
    font-size: 18px;
    font-weight: 500;
    color: var(--ss-green-800);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    transition: color .3s ease;
}
.ssdj_article_title_container::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -2px;
    width: 100%;
    height: 2px;
    background: var(--ss-gold);
    transform: scaleX(0);
    transform-origin: left;
    transition: transform .35s cubic-bezier(.22,.61,.36,1);
}
.ssdj_articleItem_container:hover .ssdj_article_title_container {
    color: var(--ss-gold);
}
.ssdj_articleItem_container:hover .ssdj_article_title_container::after {
    transform: scaleX(1);
}
.ssdj_article_date_container {
    width: 100%;
    font-size: 13px;
    color: var(--ss-gold);
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 6px 0 8px;
}
.ssdj_article_words_container {
    width: 100%;
    font-size: 14px;
    line-height: 24px;
    color: #5f6f66;
    display: -webkit-box;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.ssdj_articlePage_container {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
}

// ============ 响应式 ============
@media screen and (max-width: 900px) {
    .hxbk_grid { grid-template-columns: repeat(3, 1fr); }
}
@media screen and (max-width: 768px) {
    .ss_title { font-size: 24px; }
    .hxbk_grid { grid-template-columns: repeat(2, 1fr); }
    .hxbk_card { height: 240px; }
    .ssdj_carousel_container { height: 360px; }
    .ssdj_carousel_content_container { flex-direction: column; padding: 10px; }
    .ssdj_carousel_img_container { width: 100%; height: 160px; }
    .ssdj_carousel_words_container { width: 100%; padding: 8px 4px; }
    .ssdj_carousel_text_container { height: 140px; -webkit-line-clamp: 5; }
    .ssdj_article_img_container { width: 112px; height: 82px; flex-basis: 112px; }
    .ssdj_articleItem_container { gap: 12px; padding: 14px 4px; }
    .ssdj_article_title_container { font-size: 16px; }
    .ssdj_article_words_container { -webkit-line-clamp: 2; }
}
@media screen and (max-width: 500px) {
    .tabs_btns_container { gap: 6px; padding: 10px 4px; }
    .gyss_btn { padding: 6px 12px; font-size: 13px; }
    .ssry_grid { grid-template-columns: repeat(auto-fill, minmax(140px, 1fr)); gap: 12px; }
    .ssry_card_img { height: 150px; }
    .hxbk_grid { grid-template-columns: 1fr; }
    .hxbk_card { height: 200px; }
    .czlc_node { gap: 12px; }
    .czlc_year { font-size: 19px; }
    .ssdj_article_img_container { width: 96px; height: 72px; flex-basis: 96px; }
    .ssdj_articleItem_container { gap: 10px; }
    .ssdj_article_title_container { font-size: 15px; }
}
</style>
